import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowUp } from 'lucide-react';
export function ScrollToTop() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <motion.button onClick={scrollToTop} className="fixed bottom-8 right-8 w-14 h-14 bg-gradient-to-br from-teal-500 to-emerald-500 text-white rounded-full flex items-center justify-center shadow-elegant hover:shadow-elegant-hover transition-smooth z-50" initial={{
    opacity: 0,
    scale: 0
  }} animate={{
    opacity: showScrollTop ? 1 : 0,
    scale: showScrollTop ? 1 : 0
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} aria-label="Scroll to top" data-id="element-259">
      <ArrowUp className="w-6 h-6" strokeWidth={2.5} data-id="element-260" />
    </motion.button>;
}